<ng-container [ngTemplateOutlet]="transcriptionReceived ? viewEditTranscription : processingTranscription" />

<div class="d-flex justify-content-between align-items-center mt-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <pp-button [disabled]="form.invalid || !transcriptionReceived || transcriptionEditMode"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Primary"
        (buttonClick)="submitAndGoToNextStep()">Next</pp-button>
</div>

<ng-template #uploadStatusIndicator>
    @if (uploadProgress > 0 && !uploadComplete()) {
        <div class="upload-progress-inline d-flex align-items-center gap-6">
            <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
            <div class="upload-progress-bar-track">
                <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
            </div>
        </div>
    } @else if (uploadComplete() && !processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Processing" [src]="resolveImageIcon('time')" />
            <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
        </div>
    } @else if (processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Uploaded" src="/assets/images/icons/check-circle-solid-primary.svg" />
            <span class="fs-6 fw-semi-bold text-nowrap">Your media has been uploaded</span>
        </div>
    } @else {
        <div></div>
    }
</ng-template>

<ng-template #viewEditTranscription>
    <div class="flex-fill container-fluid">
        <form [formGroup]="form" class="d-flex flex-column gap-8">
            <div class="row">
                <div class="col-12 d-flex justify-content-between align-items-center px-0">
                    <span class="heading-4 fw-semi-bold">Transcription</span>
                    <pp-button [shape]="buttonShape.Square"
                        [variant]="buttonVariant.Secondary"
                        (buttonClick)="toggleEditMode()">
                        <div class="d-flex align-items-center gap-6">
                            <img [src]="transcriptionEditMode ?
                                '/assets/images/icons/floppy-disk-oddr.svg' :
                                '/assets/images/icons/edit-oddr.svg'"
                                [alt]="transcriptionEditMode ? 'Save transcription' : 'Edit transcription'" />
                            <span>{{ transcriptionEditMode ? 'Save': 'Edit' }} transcription</span>
                        </div>
                    </pp-button>
                </div>
            </div>
            <div class="row">
                <div class="col-12 px-0">
                    @if (transcriptionReceived) {
                        @if (transcriptionEditMode) {
                            <pp-text-area id="muTranscription" [form]="form" [labelIsHidden]="true" />
                        }
                        @else if (transcriptionText !== '') {
                            <div class="card">
                                <div class="card-body">
                                    <div>{{ transcriptionText }}</div>
                                </div>
                            </div>
                        }
                        @else {
                            <pp-alert [type]="alertType.Transparent"
                                message="This video did not generate a transcription. If you would like to add one, click 'Edit Transcription' and provide a manual transcription." />
                        }
                    }
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #processingTranscription>
    <div class="d-flex flex-column justify-content-center h-100">
        <div class="d-flex justify-content-center align-items-center p-10">
            <div class="d-flex flex-column gap-10">
                <div class="d-flex flex-column align-items-center gap-6">
                    <div class="d-inline-block pulsing">
                        <img alt="Information" [src]="resolveImageIcon('info')" />
                    </div>
                    <div class="d-flex flex-column">
                        <span class="fs-6 fw-semi-bold">We are transcribing your media. This may take a few minutes.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
